import { isPanePinningEnabled } from './isPanePinningEnabled';
import { clearPendingAutoOpenOperation, getPendingAutoOpenOperation } from './tryAutoOpen';

export default function tryRunPendingAutoOpenOperation(): void {
    if (!isPanePinningEnabled()) {
        return;
    }

    const pendingAutoOpenOperation = getPendingAutoOpenOperation();
    if (pendingAutoOpenOperation) {
        const isAutoOpenComplete = pendingAutoOpenOperation();
        if (isAutoOpenComplete !== false) {
            clearPendingAutoOpenOperation();
        }
    }
}
